import { render, staticRenderFns } from "./WaitingSupervisorPlagueMonitoring.vue?vue&type=template&id=90fb2616&scoped=true&lang=html&"
import script from "./WaitingSupervisorPlagueMonitoring.vue?vue&type=script&lang=js&"
export * from "./WaitingSupervisorPlagueMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fb2616",
  null
  
)

export default component.exports